exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".admin-support-logo {\n  width: 48px; }\n\n.content-box--header.admin-support-logo {\n  padding-top: 0px;\n  background: #fff; }\n", ""]);

